import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Text } from 'react-onei';

const getBackgroundColor = (status) => {
    switch (status) {
        case 'current':
            return "#F16E00";
        case 'previous':
        case 'last':
            return "#333";
        default:
            return "#DDD";
    }
};

const getLabelColor = (status) => {
    switch (status) {
        case 'current':
        case 'previous':
        case 'last':
            return 'white';
        default:
            return 'black';
    }
};

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 0 1rem;
  background-color: ${props => props.backgroundColor};
  width: 100%;
  clip-path: polygon(0% 0%, calc(100% - 19px) 0%,100% 50%, calc(100% - 19px) 100%, 0% 100%);
`;

const Indication = ({ label, status }) => (
    <Wrapper backgroundColor={getBackgroundColor(status)}>
        <Text bold color={getLabelColor(status)} size="l">
            {label}
        </Text>
    </Wrapper>
);

Indication.propTypes = {
    label: PropTypes.string,
    status: PropTypes.oneOf(['previous', 'last', 'current', 'next']),
};

export default Indication;
